<template>
  <main>
    <php-loading v-if="! phpLoaded"></php-loading>
    <div class="w-full h-screen overflow-x-hidden flex flex-col">
      <navbar></navbar>
      <div class="flex-1 h-full flex">
        <div class="flex h-full flex-1 flex-row w-full">
          <Settings v-if="showSettings" />
          <Documentation v-if="showDocumentation" />

          <Toolbar />

          <template v-if="mode === 'cli'">
            <Editor
              classes="w-1/2"
              v-model="code"
              documentationProperty="cliCode"
              :defaultCode="defaultCliCode()"
              name="code"
              :loading="loading"
            ></Editor>

            <php-output></php-output>
          </template>

          <template v-if="mode === 'http'">
            <div class="flex w-1/2 flex-col">
              <Editor
                classes="w-full"
                v-model="controller"
                documentationProperty="controllerCode"
                :defaultCode="defaultControllerCode()"
                name="controller"
                :loading="loading"
              ></Editor>

              <Editor
                classes="w-full border-t border-gray-600"
                v-model="view"
                documentationProperty="viewCode"
                :defaultCode="defaultViewCode()"
                name="view"
                :loading="loading"
              ></Editor>
            </div>

            <html-output></html-output>
          </template>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import hotkeys from 'hotkeys-js';
import { debounce } from 'lodash';
import ApiClient from '../apiClient';
import defaults from '../defaults';

import PhpLoading from './Output/PhpLoading.vue';
import Documentation from './Documentation/Documentation.vue';
import Editor from './Editors/Editor.vue';
import Output from './Output/Output.vue';
import HtmlOutput from './Output/HtmlOutput.vue';
import Settings from './Nav/Settings.vue';
import Toolbar from './Nav/Toolbar.vue';
import Navbar from './Nav/Navbar.vue';
import Footer from './Nav/Footer.vue';

export default {
  components: {
    'p-footer': Footer,
    Settings,
    Navbar,
    Toolbar,
    'php-loading': PhpLoading,
    'php-output': Output,
    'html-output': HtmlOutput,
    Editor,
    Documentation,
  },
  data() {
    return {
      showSettings: false,
      phpLoaded: false,
      loading: false,
      id: null,
      code: null,
      controller: null,
      view: null,
      output: '',
      error: null,
      preferences: {
        fontSize: 18,
        lineHeight: 1.5,
        autoEvaluate: true,
        lineNumbers: true,
        lineWrapping: true,
        theme: 'Dracula',
        font: 'Fira Code',
      }
    };
  },
  watch: {
    $route() {
      this.onMount();
    },
    code(to, from) {
      this.$store.dispatch("setCode", to);
      this.onInputsChange(to, from);
    },
    controller(to, from) {
      this.$store.dispatch("setController", to);
      this.execute();
    },
    view(to, from) {
      this.$store.dispatch("setView", to);
      this.execute();
    },
  },
  methods: {

    defaultCliCode() {
      return `/*
|-------------------------------------------
| Welcome to Tinkerwell Web
|-------------------------------------------
|
| Tinkerwell Web allows you to try out PHP and Laravel all from your browser.
| You have access to all Laravel classes and an in-memory SQLite database.
| Go ahead, and try it out by pressing the run button (CTRL+R).
|
| You can find the Laravel documentation with a lot of ready-to-use
| code snippets by clicking the Laravel icon in the Toolbar.
|
*/

echo 'Hello World';

`;
    },

    defaultViewCode() {
      return `<!DOCTYPE html>
<html class="h-full" lang="{{ str_replace('_', '-', app()->getLocale()) }}">
    <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">

        <title>Tinkerwell</title>

        <!-- Styles -->
        <link href="https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css" rel="stylesheet">

    </head>
    <body class="h-full">
        <div class="flex justify-center items-center h-full">
            <div class="text-center">
                <div class="text-6xl text-gray-700 font-bold">
                    Tinkerwell
                </div>

                <div class="uppercase font-bold text-sm text-gray-600">
                    <a href="https://tinkerwell.app">Get Tinkerwell App</a>
                </div>
            </div>
        </div>
    </body>
</html>`;
    },

    defaultControllerCode() {
      return `class TinkerwellController {

    public function index() {
      return view('__tinker__::tinkerwell');
    }

}`;
    },


    execute: debounce(function () { // eslint-disable-line
      this.output = null;

      if (!this.phpLoaded) return;

      if (this.$store.state.Code.autoEvaluate) {
        this.$root.$emit('php.run.tinkerwell');
      }
    }, 500),
    onInputsChange(to, from) {
      if (!from) return;
      this.execute();
    },

    async loadSnippet(hash) {
      const savedSnippet = await ApiClient.load(hash)

      this.$store.dispatch("loadSnippet", savedSnippet);
    },

    onMount() {

      if (this.$route.params.snippet && this.$route.params.snippet !== this.$store.state.Code.savedHash) {
        setTimeout(() => {
          this.loadSnippet(this.$route.params.snippet);
        }, 350)
      }


      hotkeys.filter = () =>{
        return true;
      };

      hotkeys('ctrl+r', () =>{
        this.$root.$emit('php.run.tinkerwell');
      });
    },
  },
  computed: {
    showDocumentation() {
      return this.$store.state.Code.showDocumentation;
    },
    mode() {
      return this.$store.state.Code.mode;
    },
    isSavedPlayground() {
      return this.id !== null;
    },
  },
  mounted() {
    this.$root.$on('php.loaded', () => {
      this.phpLoaded = true;
    });
    this.onMount();
  },

};
</script>

<style scoped>

</style>
